import axios from 'axios';
import isTokenExpired from './checkTokenExpiration';

// Flag to track redirection status
let isRedirecting = false;

const createApiInstance = (navigate) => {
  
  const api = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/auth`,
  });
  
  api.interceptors.request.use(
    async (config) => {
      const token = localStorage.getItem('authToken');
      const sessionId = localStorage.getItem('sessionId');
      
      if(!isTokenExpired(token)){
        config.headers['Authorization'] = `Bearer ${token}`;
      }else{
        // If we're already redirecting, just throw the cancel without initiating another redirect
        if (isRedirecting) {
          throw new axios.Cancel('Token expired');
        }
        
        // Set redirection flag to prevent multiple redirects
        isRedirecting = true;
        
        if(sessionId){
          try {
            await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/auth/session/terminate`, {}, {
              headers:{
                'x-session-id': sessionId,
                'Authorization': `Bearer ${token}`
              },
            });
          } catch (error) {
            console.log('Error ending session:', error);
          }
        }

        localStorage.removeItem('authToken');
        localStorage.removeItem('sessionId');
        localStorage.removeItem('viewedPages');
        localStorage.removeItem('selectedClient');
        localStorage.removeItem('selectedFranchisee');
        
        navigate('/magic-link-request');
        throw new axios.Cancel('Token expired');
      }

      if (sessionId) {
        config.headers['x-session-id'] = sessionId;
      }

      return config;
    },
    (error) => Promise.reject(error)
  );

  // Add response interceptor to reset the redirection flag when responses are successful
  api.interceptors.response.use(
    (response) => {
      isRedirecting = false;
      return response;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  return api;
  
}

export default createApiInstance;